export enum BulkAddUIMessages {
  CustomerNumber = 'Please add a Customer Number',
  SiteNumber = 'Please add a Site Number',
  Make = 'Please add a Make',
  Model = 'Please add a Model',
  SerialNumber = 'Please add a Serial Number',
  SerialNumberDup = 'Duplicate Serial Numbers',
  ManufacturedYear = 'Please enter a year between 1980 and the current year',
  InstallDate = 'Please format the date MM/DD/YYYY',
  CustomerAssetNumber = 'Please enter a customer asset number with 150 characters or less'
}
